import Brand from "../../../shared/components/Brand";
import Button from "../../../shared/components/Button";
import Input from "../../../shared/components/Input";
import LinearLayout from "../../../shared/components/LinearLayout";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { useResetPassword } from "../services";
import { isApiError } from "@/shared/api";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { mutateAsync: resetPassword, isPending } = useResetPassword();

  const isValid = password.length >= 8;
  const match = confirmPassword !== "" && confirmPassword === password;

  const onSubmit = async () => {
    if (!isValid || !match) return;

    if (!token) {
      toast.error("Invalid or missing reset token");
      return;
    }

    try {
      await resetPassword({ password, token });
      toast.success("Password reset successfully. Please sign in.");
      navigate("/sign-in");
    } catch (error) {
      let message = "Unable to reset password. Please try again.";
      let requestId: string | undefined;

      if (isApiError(error)) {
        message = error.message;
        requestId = error.requestId;
      } else if (error instanceof Error) {
        message = error.message;
      }

      toast.error(message, {
        description: requestId ? `Request ID: ${requestId}` : undefined,
      });
    }
  };

  return (
    <div className="px-6 flex flex-col items-center justify-between h-full">
      <Brand size="xl" />
      <div className="w-full">
        <LinearLayout orientation="vertical">
          <div className="text-center align-middle mx-auto space-y-5">
            <h1 className="text-white text-[20px] leading-[24px] font-medium ">
              Reset Password
            </h1>
            <p className="text-white text-sm font-sm opacity-50">
              Create a new password for your account.
            </p>
            <Input
              label="New Password"
              type="password"
              placeholder="Enter new password"
              labelColor="label-dark"
              fluid
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Input
              label="Confirm New Password"
              type="password"
              placeholder="Re-enter new password"
              labelColor="label-dark"
              fluid
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <div className="text-xs">
              <p className={isValid ? "text-green-600" : "text-red-600"}>
                {isValid ? "✓" : "✕"} At least 8 characters
              </p>
              <p className={match ? "text-green-600" : "text-red-600"}>
                {match ? "✓" : "✕"} Passwords match
              </p>
            </div>
            <Button
              variant="primary"
              fluid
              onClick={onSubmit}
              loading={isPending}
              disabled={!isValid || !match || isPending}>
              Reset Password
            </Button>
          </div>
        </LinearLayout>
      </div>
      <p className="text-center text-label-dark text-sm pb-10">
        Remember your password?{" "}
        <Link to="/sign-in" className="text-gray-200 underline">
          Sign in
        </Link>
      </p>
    </div>
  );
}
